import {FC, useLayoutEffect, useRef} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {UserModel} from '../../../modules/auth/models/UserModel'

export const WelcomeBanner: FC = () => {
  const user = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  const firstName = (user?.firstName ?? '').trim()
  const bannerRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const banner = bannerRef.current
    const header = document.getElementById('kt_header')
    if (!banner || !header) return
    const headerHeight = header.getBoundingClientRect().height
    const overrides: Array<{el: HTMLElement; pt: string; mt: string}> = []
    let node: HTMLElement | null = banner.parentElement
    while (node && node !== document.body) {
      const cs = getComputedStyle(node)
      const pt = parseFloat(cs.paddingTop) || 0
      const mt = parseFloat(cs.marginTop) || 0
      const isHeaderOffset = Math.abs(pt - headerHeight) < 1
      if ((pt > 0 && !isHeaderOffset) || mt > 0) {
        overrides.push({el: node, pt: node.style.paddingTop, mt: node.style.marginTop})
        if (pt > 0 && !isHeaderOffset) node.style.paddingTop = '0'
        if (mt > 0) node.style.marginTop = '0'
      }
      node = node.parentElement
    }
    return () => {
      overrides.forEach(({el, pt, mt}) => {
        el.style.paddingTop = pt
        el.style.marginTop = mt
      })
    }
  }, [])

  return (
    <div
      ref={bannerRef}
      className='welcome-banner-main-dashboard'
      style={{
        position: 'relative',
        width: 'calc(100% + 208px)',
        marginLeft: -104,
        marginRight: -104,
        marginBottom: 40,
        height: 158,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'flex-end',
        padding: '0 104px 18px',
        color: '#ffffff',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      }}
    >
      <img
        src='/media/nobilis/welcome-banner.png'
        alt=''
        aria-hidden='true'
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center center',
          filter: 'grayscale(100%)',
          zIndex: 0,
        }}
      />
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(90deg, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0.9) 100%)',
          zIndex: 1,
        }}
      />
      <div style={{position: 'relative', zIndex: 2, display: 'flex', alignItems: 'baseline', gap: 12}}>
        <span
          style={{
            fontFamily: 'Oswald, sans-serif',
            fontWeight: 500,
            fontSize: 22,
            lineHeight: 1.2,
            letterSpacing: 0,
          }}
        >
          Welcome,
        </span>
        <span
          style={{
            fontFamily: '"Cormorant SC", serif',
            fontWeight: 500,
            fontSize: 28,
            lineHeight: 1.2,
            letterSpacing: 0,
          }}
        >
          {firstName}
        </span>
      </div>
    </div>
  )
}
